import { render, staticRenderFns } from "./betriebsanweisungType.vue?vue&type=template&id=b4ad74ea"
import script from "./betriebsanweisungType.vue?vue&type=script&lang=js"
export * from "./betriebsanweisungType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports